import { InjectionToken, Type } from '@angular/core';

export namespace Modal {

  export interface Init {
    component: Type<unknown>;
    data: unknown;
    callback: (result: unknown) => void;
  }

  export interface Ref<TData = unknown, TResult = unknown> {
    readonly data: TData;
    close: (result: TResult) => void;
  }

  export const REF = new InjectionToken('Modal reference');

}
